/**
 * UNA TAREA QUE ESPERA A OTRA SE VE BLOQUEADA Y SE DICE POR QUE (SALV-DEPENDENCIAS-T1, parte vista; SI de Ares #24204).
 *
 * DE DONDE SALE. nexo-api PR 461 (a6456f3, servido 1.6.699), migracion 2026_10_10_004:
 *   - metadata.depende_de = codigos de tarea; los que no estan servidos quedan en metadata.bloqueada_por (LISTA).
 *     La base solo cuenta la marca si es una lista no vacia: hay filas viejas con "bloqueada_por":"SE-T2" (texto)
 *     que NO bloquean (CASE de tareas_bloqueo_al_actualizar, head 866e142).
 *   - una tarea con la marca no pasa a in_progress ni a completed:
 *       RAISE 'TAREA_BLOQUEADA: <code> espera a <A, B> (metadata.bloqueada_por); se libera sola cuando esa se cierra o sale su [VIVO]'
 *     TasksController (PUT /{id} y POST /{id}/status) lo devuelve como 409 ProblemDetails
 *     { type: ".../problems/tarea_bloqueada", title: "La tarea esta bloqueada", detail: <el mensaje>, status: 409 }.
 *   - solo el CAMBIO de estado frena (NEW.status IS DISTINCT FROM OLD.status): editar titulo, pasos o etiquetas no.
 *
 * Sin DOM: lo prueba scripts/check-tareas-bloqueadas.mjs con la forma EXACTA del 461.
 */
import { motivoPuerta } from './puertaTarea.js';

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** Los codigos que la tarea espera, con la misma regla de la base: solo una lista cuenta. */
export function bloqueadaPor(tarea) {
  const md = tarea?.metadata ?? tarea?.Metadata ?? {};
  const v = md?.bloqueada_por;
  return Array.isArray(v) ? v.map(texto).filter(Boolean) : [];
}

/** Una pendiente con la marca se pinta bloqueada (no libre): asi la ve quien busca que tomar. */
export function estaBloqueada(tarea) {
  return texto(tarea?.status ?? tarea?.Status).toLowerCase() === 'pending' && bloqueadaPor(tarea).length > 0;
}

/** La etiqueta de la fila: "Bloqueada por SALV-T2" o "Bloqueada por SALV-T2 y 1 mas". */
export function etiquetaBloqueo(tarea) {
  const codigos = bloqueadaPor(tarea);
  if (!codigos.length) return '';
  return 'Bloqueada por ' + codigos[0] + (codigos.length > 1 ? ` y ${codigos.length - 1} mas` : '');
}

/** Que espera, leido del 409 TAREA_BLOQUEADA; [] si no es ese error. */
export function codigosDelBloqueo(res) {
  if (Number(res?.code) !== 409) return [];
  const det = texto(res?.details?.detail) || texto(res?.error);
  if (!/TAREA_BLOQUEADA/.test(det) && !/problems\/tarea_bloqueada$/.test(texto(res?.details?.type))) return [];
  const m = /espera a (.+?) \(metadata\.bloqueada_por\)/.exec(det);
  return m ? m[1].split(',').map(texto).filter(Boolean) : [];
}

/**
 * Que decir cuando una tarea no se pudo crear o cambiar: el bloqueo por su causa, y lo demas como la puerta.
 */
export function motivoTarea(res) {
  const det = texto(res?.details?.detail) || texto(res?.error);
  const esBloqueo = Number(res?.code) === 409 && (/TAREA_BLOQUEADA/.test(det) || /problems\/tarea_bloqueada$/.test(texto(res?.details?.type)));
  if (esBloqueo) {
    const codigos = codigosDelBloqueo(res);
    const cuales = codigos.length ? codigos.join(', ') : 'otra tarea';
    return `Esta tarea espera a ${cuales}: no se puede tomar ni cerrar todavia. Se libera sola cuando ${codigos.length > 1 ? 'esas se cierran' : 'esa se cierra'} o sale su VIVO.`;
  }
  return motivoPuerta(res);
}
